'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reactProptypeConditionalRequire = require('react-proptype-conditional-require');

var _reactProptypeConditionalRequire2 = _interopRequireDefault(_reactProptypeConditionalRequire);

var _Cross = require('@deliveroo/icon-set/react/Cross');

var _Cross2 = _interopRequireDefault(_Cross);

var _ArrowLeft = require('@deliveroo/icon-set/react/ArrowLeft');

var _ArrowLeft2 = _interopRequireDefault(_ArrowLeft);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Span = require('../Span');

var _Span2 = _interopRequireDefault(_Span);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-did-mount-set-state */


var styles = {
  'overlay': 'ccl-2c37a64021f7a45f',
  'afterOpen': 'ccl-ec50bdf4e930cfb0',
  'bottomSheet': 'ccl-63bb2b264d6e455f',
  'fullscreen': 'ccl-9a1312bc20601cd9',
  'noOverlayTransition': 'ccl-56fea8853499c21a',
  'visibilityHidden': 'ccl-a9f3e70cf3099a9b',
  'contentWrapper': 'ccl-f967fb02d7bd182a',
  'innerContentWrapper': 'ccl-c334cd44f5e42880',
  'content': 'ccl-9bcf8db942e088a2',
  'hasOverflow': 'ccl-afd7f53ad24cb4ea',
  'footer': 'ccl-c0cfdd4489ca1c33',
  'contentPadding': 'ccl-42bb256c439a40df',
  'edgeToEdge': 'ccl-77ae1097527a8292',
  'floatingCloseButton': 'ccl-022adec8b2f34033',
  'header': 'ccl-ef0aeb266e0ad3b1',
  'normal': 'ccl-2753a6f8e07b1d86',
  'translucent': 'ccl-af83cfe861325fae',
  'headerTitle': 'ccl-69b8a9a8c9f065ef',
  'headerIcon': 'ccl-d85e9b67a3110f25',
  'headerIconButton': 'ccl-caaf537be0dac3d8'
};


var HEADER_TITLE_ID = 'modal-header-title';

/**
 * Modals... Modals everywhere.
 */

// eslint-disable-next-line react/no-deprecated

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal(props) {
    _classCallCheck(this, Modal);

    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this.onCloseIntent = _this.onCloseIntent.bind(_this);
    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // When the modal is open on the server side render (vs being triggered in the client)
      // react-modal seems to error and cause this warning to be displayed: http://bit.ly/2EOmpun
      // Setting the app element here and _then_ opening it seems to work on the server and client.
      // Future versions of react-modal might address this at which
      // point we can remove this work-a-round.
      _reactModal2.default.setAppElement(this.props.appElement);
      this.setState({ isOpen: this.props.isOpen });
    }

    // We are tracking the isOpen prop using internal state so we can open it once mounted
    // and not encounter issues on the SSR, see componentDidMount for more information.

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var isOpen = this.state.isOpen;

      if (nextProps.isOpen !== isOpen) {
        this.setState({
          isOpen: nextProps.isOpen
        });
      }
    }
  }, {
    key: 'onCloseIntent',
    value: function onCloseIntent() {
      if (this.props.onClose) {
        this.props.onClose();
      }
    }
  }, {
    key: 'renderHeader',
    value: function renderHeader() {
      var _props = this.props,
          headerTitle = _props.headerTitle,
          headerTheme = _props.headerTheme,
          closeButtonLabel = _props.closeButtonLabel,
          backButtonLabel = _props.backButtonLabel,
          onBack = _props.onBack,
          onClose = _props.onClose;

      var textColor = headerTheme === 'translucent' ? 'white' : 'black';

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames4.default)(styles.header, styles[headerTheme]) },
        _react2.default.createElement(
          'div',
          { className: styles.headerIcon },
          onBack && _react2.default.createElement(
            'button',
            {
              className: styles.headerIconButton,
              onClick: onBack,
              type: 'button',
              'aria-label': backButtonLabel
            },
            _react2.default.createElement(_Icon2.default, { component: _ArrowLeft2.default })
          )
        ),
        headerTitle && _react2.default.createElement(
          'h1',
          { className: styles.headerTitle, id: HEADER_TITLE_ID },
          _react2.default.createElement(
            _Span2.default,
            { isBold: true, color: textColor },
            headerTitle
          )
        ),
        onClose && _react2.default.createElement(
          'div',
          { className: styles.headerIcon },
          _react2.default.createElement(
            'button',
            {
              className: styles.headerIconButton,
              onClick: this.onCloseIntent,
              type: 'button',
              'aria-label': closeButtonLabel
            },
            _react2.default.createElement(_Icon2.default, { component: _Cross2.default })
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var _props2 = this.props,
          hasOverflow = _props2.hasOverflow,
          children = _props2.children,
          aria = _props2.aria,
          headerTitle = _props2.headerTitle,
          type = _props2.type,
          renderBackground = _props2.renderBackground,
          onClose = _props2.onClose,
          isContentEdgeToEdge = _props2.isContentEdgeToEdge,
          renderFooter = _props2.renderFooter,
          isVisibilityHidden = _props2.isVisibilityHidden,
          isOverlayTransitionDisabled = _props2.isOverlayTransitionDisabled,
          closeButtonLabel = _props2.closeButtonLabel;
      var isOpen = this.state.isOpen;

      var ariaAttributes = _extends({}, aria, headerTitle ? { labelledby: HEADER_TITLE_ID } : {});
      var areChildrenRenderFunc = typeof children === 'function';

      return _react2.default.createElement(
        _reactModal2.default,
        {
          aria: ariaAttributes,
          onRequestClose: this.onCloseIntent,
          isOpen: isOpen,
          className: {
            base: (0, _classnames4.default)(styles.contentWrapper, styles[type]),
            afterOpen: styles.afterOpen,
            // Even though we don't have a close animation, we have to provide an
            // empty string here. Otherwise react-modal will complain about invalid
            // props being supplied.
            beforeClose: ''
          },
          overlayClassName: {
            base: (0, _classnames4.default)(styles.overlay, styles[type], (_classnames = {}, _defineProperty(_classnames, styles.visibilityHidden, isVisibilityHidden), _defineProperty(_classnames, styles.noOverlayTransition, isOverlayTransitionDisabled), _classnames)),
            afterOpen: styles.afterOpen,
            beforeClose: ''
          }
        },
        renderBackground ? renderBackground() : null,
        _react2.default.createElement(
          'div',
          { className: styles.innerContentWrapper },
          type !== 'fullscreen' && onClose && _react2.default.createElement(
            'button',
            {
              className: styles.floatingCloseButton,
              onClick: this.onCloseIntent,
              type: 'button',
              'aria-label': closeButtonLabel
            },
            _react2.default.createElement(_Icon2.default, { component: _Cross2.default })
          ),
          !areChildrenRenderFunc && type === 'fullscreen' && this.renderHeader(),
          _react2.default.createElement(
            'div',
            {
              className: (0, _classnames4.default)(styles.content, _defineProperty({}, styles.hasOverflow, areChildrenRenderFunc && hasOverflow))
            },
            areChildrenRenderFunc ? children(this.renderHeader()) : _react2.default.createElement(
              'div',
              {
                className: (0, _classnames4.default)(styles.contentPadding, isContentEdgeToEdge && styles.edgeToEdge)
              },
              children
            )
          ),
          renderFooter && _react2.default.createElement(
            'div',
            { className: styles.footer },
            renderFooter()
          )
        )
      );
    }
  }]);

  return Modal;
}(_react.Component);

Modal.displayName = 'Modal';


Modal.propTypes = {
  /**
   * The contents of your modal.
   */
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]).isRequired,

  /**
   * Whether the modal is open or no.
   */
  isOpen: _propTypes2.default.bool.isRequired,

  /**
   * Event handler for when the user want's to close the modal by clicking on
   * the background, pressing escape or pressing the close cross. If not provided,
   * the modal will not be closable.
   */
  onClose: _propTypes2.default.func,

  /**
   * The type of modal you'd like to present. Depending on the type, the Modal
   * will responsively adjust per screen size.
   */
  type: _propTypes2.default.oneOf(['bottomSheet', 'dialog', 'fullscreen']),

  /**
   * Function that returns some node(s) to be shown in the footer.
   */
  renderFooter: _propTypes2.default.func,

  /**
   * Event handler for when the user presses back. If not provided, no back
   * arrow will be shown.
   */
  onBack: _propTypes2.default.func,

  /**
   * By default the content of the modal is given some edgepadding. Use this
   * if you need edge-to-edge content for things like maps etc. This only has
   * effect if you provide React nodes as children vs a render function.
   */
  isContentEdgeToEdge: _propTypes2.default.bool,

  /**
   * By default the content of the modal will use overflow: hidden, which will
   * crop the contents of the modal on tablet and above where the modal size
   * won’t occupy the full viewport. This prop allows you to disable that
   * behaviour so that the contents of an explicitly custom modal can overflow
   * the modal. This is useful for things like autosuggestion lists which may
   * need to overhang the modal content area itself.
   */
  hasOverflow: _propTypes2.default.bool,

  /**
   * When of type 'fullscreen' this controls the appearance of the top header.
   * Ignored when used in combination with other types since no header is shown
   * in those cases.
   */
  headerTheme: _propTypes2.default.oneOf(['normal', 'translucent']),

  /**
   * The title to show in the header. If provided, will be used as for
   * as the value of the `aria-labelledby` attribute.
   */
  headerTitle: _propTypes2.default.string,

  /**
   * Allows you to specify the portion of your app that should be hidden
   * (via aria-hidden) to prevent assistive technologies such as screenreaders
   * from reading content outside of the content of your modal.
   */
  appElement: _propTypes2.default.string.isRequired,

  /**
   * Additional aria attributes to pass to react-modal. Accepts an object where
   * the keys are the names of the attributes without the prefix `aria-`.
   */
  aria: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types

  /**
   * If you need to have something behind the modal you can render it using this prop.
   * You can then use absolute positioning to lay it out correclty.
   */
  renderBackground: _propTypes2.default.func,

  /**
   * if you need to visually hide the modal without closing it so you don't
   lose its content's state.
   */
  isVisibilityHidden: _propTypes2.default.bool,

  /**
   * Disable the overlay transition on open. Useful when you're opening a modal
   from within a modal to avoid flickering from overlapping overlays.
   */
  isOverlayTransitionDisabled: _propTypes2.default.bool,

  /**
   * Close button label required for accessibility.
   */
  closeButtonLabel: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.string, function (props) {
    return props.onClose;
  }),

  /**
   * Back button label required for accessibility.
   */
  backButtonLabel: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.string, function (props) {
    return props.onBack;
  })
};

Modal.defaultProps = {
  onBack: undefined,
  onClose: undefined,
  renderFooter: undefined,
  type: 'dialog',
  isContentEdgeToEdge: false,
  hasOverflow: false,
  headerTheme: 'normal',
  headerTitle: '',
  aria: undefined,
  renderBackground: undefined,
  isVisibilityHidden: false,
  isOverlayTransitionDisabled: false,
  closeButtonLabel: undefined,
  backButtonLabel: undefined
};

exports.default = Modal;